import '../../core-components/outer-footer/outer-footer';
